import React, {Component} from 'react'
import {CSSTransition, TransitionGroup} from 'react-transition-group'
import CloseBtn from '../../components/CloseBtn'
import InnerWrap from '../../components/InnerWrap'
import SectionMenu from '../../components/SectionMenu'
import SectionMenuLink from '../../components/SectionMenu/SectionMenuLink'
import BackSound from '../../components/BackSound'
import Video from '../../components/Video'
import * as routes from '../../const/routes'
import * as videos from '../../const/videos'
import {withUiContext} from "../../UiContext";
import MenuBtn from "../../components/MenuBtn";
import NavContent from "../../components/NavContent";
import Languages from "../../const/languages";

class Podst extends Component {

    state = {
        driver: this.props.ui.driver,
        navContent: false,
    }

    toggleNav = (e) => {
        this.setState((prevState) => ({navContent: !prevState.navContent}))
    }

    onEnded = () => {
        this.setState({driver: false})
    }

    render() {
        const { driver, navContent } = this.state

        return (
            <InnerWrap video={videos.bg_podstancii} title={!driver && Languages.substations}>
                <div className="hud__container-content">
                    { !driver && (
                        <MenuBtn
                            className={`animated ${!navContent ? 'fadeInLeft' : 'fadeOutLeft'}`}
                            onClick={this.toggleNav}
                            onMouseEnter={this.props.ui.playOverSound}
                        />
                    ) }

                    <TransitionGroup className="menu-outer">
                        { navContent && (
                            <CSSTransition timeout={300} classNames="menu-transition">
                                <NavContent onClose={this.toggleNav}/>
                            </CSSTransition>
                        ) }
                    </TransitionGroup>

                    <TransitionGroup>
                        { !driver && (
                            <CSSTransition timeout={300} classNames="menu-transition">
                                <SectionMenu>
                                    <SectionMenuLink
                                        label={Languages.substation110}
                                        link={routes.PODST_110}
                                        className="nav-item-1"
                                        onMouseEnter={this.props.ui.playOverSound}
                                    />

                                    <SectionMenuLink
                                        label={Languages.substation220}
                                        link={routes.PODST_220}
                                        className="nav-item-2"
                                        onMouseEnter={this.props.ui.playOverSound}
                                    />

                                    <SectionMenuLink
                                        label={Languages.substation330}
                                        link={routes.PODST_330}
                                        className="nav-item-3"
                                        onMouseEnter={this.props.ui.playOverSound}
                                    />
                                </SectionMenu>
                            </CSSTransition>
                        ) }
                    </TransitionGroup>

                    <TransitionGroup>
                        { driver && (
                            <CSSTransition timeout={3000} classNames="fade">
                                <Video video={videos.driver} onEnded={this.onEnded}/>
                            </CSSTransition>
                        ) }
                    </TransitionGroup>
                </div>

                <div className="hud__container-controls">
                    {!driver && (
                        <BackSound navContent={navContent} />
                    )}

                    <CloseBtn link={routes.HOME}/>
                </div>
            </InnerWrap>
        )
    }
}

export default withUiContext(Podst)
